<template>
  <div>
    <ul
      class="kbx-content"
      klickbox-edit-item="progress"
      :klickbox-edit-label="$t('edit.canvas.progressbar')">
      <item-done></item-done>
      <item-active></item-active>
      <item-default></item-default>
      <item-mask></item-mask>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ItemDone from './Done';
import ItemActive from './Active';
import ItemDefault from './Default';
import ItemMask from './Mask';

export default {
  methods: mapActions([
    'canvasEnableHighlight',
  ]),
  components: {
    ItemDone,
    ItemActive,
    ItemDefault,
    ItemMask,
  },
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?aea8384e
 **/